import * as Sentry from '@sentry/react';

import { getSentryDsn, getSentryEnvironment } from './lib/config';

Sentry.init({
  dsn: getSentryDsn(),
  environment: getSentryEnvironment(),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
